export default "__VITE_ASSET__gBpeyUSe__"